import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { FullScreenLoader } from '@/components/feedback/FullScreenLoader'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { paths } from '@/routes/paths'

/** Evita que un usuario ya autenticado vuelva a ver /login. */
export function PublicOnlyRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isBootstrapping } = useAuth()

  if (isBootstrapping) {
    return <FullScreenLoader label="Verificando sesión..." />
  }

  if (isAuthenticated) {
    return <Navigate to={paths.dashboard} replace />
  }

  return children
}
